const openPopupWhenClickingToCartImage = () => {
  const cartItems = document.querySelectorAll(".cart-item");
  cartItems.forEach((cartItem) => {
    const previewBtn = cartItem.querySelector(".tee-preview-button");
    const customizationImage = cartItem.querySelector(
      ".tee-cart-thumbnail__link:not(.disable-redirect)"
    );
    if (previewBtn && customizationImage) {
      customizationImage.classList.add("disable-redirect");
      customizationImage.addEventListener("click", (e) => {
        e.preventDefault();
        previewBtn.click();
      });
    }
  });
};

document.addEventListener("DOMContentLoaded", () => {
  if (!window.location.pathname.includes("/cart")) return;

  var c = 0;
  const i = setInterval(() => {
    if (c == 20) clearInterval(i);
    c += 1;
    openPopupWhenClickingToCartImage();
  }, 200);

  const observer = new MutationObserver(() => {
    openPopupWhenClickingToCartImage();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
